import { render, staticRenderFns } from "./GlobalToast.vue?vue&type=template&id=d4809b80&"
import script from "./GlobalToast.vue?vue&type=script&lang=ts&"
export * from "./GlobalToast.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports